import { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import _ from "lodash";
import { motion } from "framer-motion"

import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import ReviewComponent from "../Commons/ReviewComponent";
import ComponentEntity from "../Component/ComponentEntity";
import { dataValidator } from "../../tools/dataValidator";
import { initScriptRun } from "../../tools/initScriptHelper";
import { conditionValidator } from "../../tools/conditionValidator";
import processLogApi from "../../api/processLogApi";
import { getAuth } from "../../slices/authSlice";
import ProcessReport from "./ProcessReport";

import { MdHome, MdBugReport } from "react-icons/md";
import { ImArrowLeft, ImArrowRight } from "react-icons/im";
import { getLabel } from "../../tools/Dictionary";

import "./Process.css";
import { Fragment } from "react";

const ProcessPage = (props) =>
{


  //Navigation
  const Navigate = useNavigate();

  //Redux
  const Auth = useSelector(getAuth);



  //Props
  const IsDesktop = props.IsDesktop;
  const Process = props.Process;
  const OnGoHome = props.OnGoHome;
  const Product = props.Product;
  const Step = props.Step;
  const InitScript = props.InitScript || props.Process.initScript || undefined;
  const Variable = useMemo(() => {
    if (!InitScript || !InitScript.isActive)
      return props.Variable;

    let updatedVariable = _.cloneDeep(props.Variable);

    initScriptRun(InitScript, updatedVariable);

    return updatedVariable;

  }
    , [InitScript, props.Variable]);
  const TestMode = props.TestMode;
  const FirstStepIndex = useMemo(() => {

    return Step[0];

  }, [Step]);

  //console.log(Variable);


  //Init
  const initValue = () => {

    let listValue = [];

    Step.forEach(s => {

      s.component.forEach(c => {

        if (!c.isVariable) return;

        let tempValue = {
          step: s._id,
          stepTitle: s.title,
          component: c._id,
          componentName: c.name,
          data: undefined,
          validation: c.data.validation,
          isDirty: false
        };

        listValue.push(tempValue);

      });

    });

    return listValue;

  };


  //State
  const [step] = useState(Step);
  const [currentStep, setCurrentStep] = useState(FirstStepIndex || undefined);
  const [path, setPath] = useState([{
    _id: FirstStepIndex._id,
    title: FirstStepIndex.title,
    navigationButton: FirstStepIndex.navigationButton
  }]);
  const [value, setValue] = useState(initValue());
  const [end, setEnd] = useState(false);
  const [review, setReview] = useState({
    sent: false,
    rating: 0,
    comment: ""
  });
  const [processLog, setProcessLog] = useState(undefined);
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm, setConfirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [report, setReport] = useState(false);

  const onChangeValueCustom = (_value, _data, _parameter = undefined) =>
  {

    try
    {

      let tempValue = _.cloneDeep(value);



      let currentValueIndex = tempValue.findIndex(v => v.component == _data._id)

      tempValue[currentValueIndex].data = _value;
      tempValue[currentValueIndex].isDirty = true;

      if (_parameter){
        tempValue[currentValueIndex].parameter = _parameter
      }



      setValue(tempValue);

      onValidateField(tempValue);

    } catch (err)
    {


      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });


    };

  };

  const onChangeValue = (e, _data) => {

    try{

      let tempValue = _.cloneDeep(value);



      let currentValueIndex = tempValue.findIndex(v => v.component == _data._id)

      tempValue[currentValueIndex].data = e.target.value;
      tempValue[currentValueIndex].isDirty = true;



      setValue(tempValue);

      onValidateField(tempValue);

    }catch(err){


      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });


    };   

  };

  const onValidateField = (_valueToValidate = undefined, _validateAll = false) => {

    let isValid = true; // Flag to track overall validity

    let currentError = { ...error };

    let Validation = []; // Array to store validation results
    let currentValidation = [];
    let currentValue = _valueToValidate || value;

    currentValue.forEach(v => {

      if (v.step != currentStep._id) return;

      if (_validateAll || v.isDirty){

        // Validate
        currentValidation = dataValidator([
          { field: v.component, value: v.data, listValidation: v.validation }
        ]);    
        
        Validation = [...Validation, ...currentValidation];

      };

    });

    Validation.forEach(validation =>
    {
      // Iterate over each validation result
      if (validation.valid)
      {
        currentError[validation.field] = ""; // If valid, clear the corresponding error field
      } else
      {
        currentError[validation.field] = validation.reason; // If invalid, set the error reason in the corresponding field
        isValid = false; // Set isValid to false if any validation fails
      }
    });

    setError(currentError); // Update the error state

    return isValid; // Return the overall validity flag

  };



  const onClickButton = (_type) => {


    switch (_type) {
      case "Next":
        onGoNext();
        break;
      case "Home":
        onGoNext(true);
        break;
      case "Back":
        onGoBack();
        break;
      default:
        break;
    }

  }

  const onGoHome = () => {

    if (OnGoHome) onAskHome();
    else onTryAgain();



  };

  const onTryAgain = () => {
    


    try
    {

      //if (OnGoHome) onAskHome();

      //Reset everything
      setReview({
        sent: false,
        rating: 0,
        comment: ""       
      });
      setValue(initValue());
      setProcessLog(undefined);
      setEnd(false);
      setCurrentStep(FirstStepIndex);
      setPath([{
        _id: FirstStepIndex._id,
        title: FirstStepIndex.title,
        navigationButton: FirstStepIndex.navigationButton,
        data: {}
      }]);

    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    };

  };

  const onAskHome = () => {

    setConfirm({
      Title: getLabel("ProcessPage", "Leave troubleshoot"),
      Message: getLabel("ProcessPage", "You are about to leave the troubleshooting mode. Please confirm if you want to quit and discard any ongoing diagnostics."),
      Cancel: getLabel("App", "No"),
      onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
      Confirm: getLabel("App", "Yes"),
      onConfirm: OnGoHome,
      Display: true
    });

  };

  const onGoBack = () => {

    try{

      if (end){

        setEnd(false);

      }else if (path.length > 1){

        let previousStep = step.find(s => s._id == path[path.length - 2]._id);

        setCurrentStep(previousStep);
        setPath(path => path.slice(0, -1));

      }


    }catch(err){

      onGoHome();

    }

  };

  const onGoNext = async(_isEnd = false) => {

    try{



      if (!onValidateField(value, true)) throw new Error("The form contains errors. Please check and fix the fields highlighted in red.");



      if (_isEnd){


        if (!TestMode) await onSendData();

        setEnd(true);

        return;

      }

      let nextStep = FindNextStep();


      if (nextStep){

        setCurrentStep(nextStep);
        setPath(path => [...path, {
          _id: nextStep._id,
          title: nextStep.title,
          navigationButton: nextStep.navigationButton
        }]);

      }else{

        if(!TestMode) await onSendData();

        setEnd(true);
      }
  


    }catch(err){

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });    

    };

  };


  const FindNextStep = () => {

    let nextCondition = currentStep.condition;

    let nextStepId = undefined;
    let nextStep = undefined;


    try{

      nextCondition.sort((a, b) =>
      {
        if (a.order <= b.order) return -1;
        if (a.order > b.order) return 1;
        return 0;
      });



      for (let i = 0; i < nextCondition.length; i++)
      {

        let currentCondition = nextCondition[i];





        if (currentCondition.data.length == 0)
        {
          nextStepId = currentCondition.processStep;
          break;
        }



        for (let j = 0; j < currentCondition.data.length; j++)
        {

          let currentData = currentCondition.data[j];

          let valid = currentData.every(g =>
          {

            return conditionValidator(g, value, Variable, Auth.User.temperatureUnit.code == "F" ? true : false);

          });


          if (valid)
          {
            nextStepId = currentCondition.processStep;
            break;
          }

        }

        if (nextStepId) break;

      }

      if (nextStepId) nextStep = step.find(s => s._id == nextStepId);


      return nextStep;


    }catch(err){

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });    
     

    }

    

  };

  const onClickRating = (_rating) => {

    setReview(review => ({
      ...review,
      rating: _rating
    }));

  }

  const onChangeComment = (e) => {

    let comment = e.target.value;

    if (comment && comment.length > 100) return;


    setReview(review => ({
      ...review,
      comment
    }));

  };

  const onSendData = async() => {


    try{


      setLoading(true);

      let currentPath = _.cloneDeep(path);

      currentPath.forEach(p => {

        p.component = value.filter(v => v.step == p._id).map(v => ({
          _id: v.component,
          value: v.data,
          parameter: v.parameter
        }));

      });

      currentPath = currentPath.filter(p => p.component.length > 0);


      let parameters = {
        _id: processLog || 0,
        process: Process._id,
        product: Product ? Product._id : undefined,
        path: currentPath
      };


      let response = await processLogApi.updateProcessLog(parameters);


      if (!response.Success)
      {

        let error = new Error()
        error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label) : undefined;

        throw error;

      }else{

        setProcessLog(response.Data ? response.Data._id : undefined);

      }

      setLoading(false);



    } catch (err)
    {

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });


    }

    

  };


  const handleClickReview = (e) => {

    if (e.key === 'Enter')
    {
      onSendReview();

    }


  };

  const onSendReview = async() => {

    try{

      setLoading(true);

      if (review.sent) throw new Error();

      if (!review.rating) throw new Error(getLabel("ProcessPage", "Please rate your experience on a scale from 1 to 5 stars."));

      if (!processLog) throw new Error();

      let parameters = {
        _id: processLog,
        rating: review.rating,
        comment: review.comment || ""
      }

      let response = await processLogApi.updateProcessLogReview(parameters);

      if (!response.Success)
      {

        let error = new Error()
        error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label) : undefined;

        throw error;

      }

      setReview(review => ({
        ...review,
        sent: true
      }));

      setLoading(false);


    }catch(err){

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });
     

    }

  };



  const onClickContact = async() => {

    try
    {

      setLoading(true);

      if (!processLog) throw new Error();

      let parameters = {
        _id: processLog
      };

      let response = await processLogApi.updateProcessLogContacted(parameters);

      if (!response.Success)
      {

        let error = new Error()
        error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label) : undefined;

        throw error;

      }

      Navigate("/contact");


    } catch (err)
    {

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });


    }

    


  };

  const onClickReport = async() => {

    setReport(true);


  };

  if (!currentStep)
  {

    return (
      <div className="page_body_cont">
        <input
          type="button"
          className="page_button"
          value={"Return"}
          onClick={onGoHome}
        />
      </div>
    );

  };

  if (end){


    return (
      <div className="page_body_cont">
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_cont">
          {TestMode &&
            <div className="process_step_title">
              [ {getLabel("ProcessPage", "End")} ]
            </div>
          }
          <div className="process_navigation_cont">
            <div className="process_navigation_col" style={{ width: "100px" }} title={getLabel("ProcessPage", "Back")}>
              <div className="process_navigation_button" onClick={onGoBack}>
                <ImArrowLeft />
              </div>
            </div>
            <div className="process_navigation_col" style={{ width: "100px" }} title={getLabel("ProcessPage", "Home")}>
              <div className="process_navigation_button" style={{ fontSize: "30px" }} onClick={onGoHome}>
                <MdHome />
              </div>
            </div>
            <div className="process_navigation_col" style={{ width: "100px" }} title={getLabel("ProcessPage", "Next")}>
            </div>
          </div>
          <motion.div className="component_cont"
            variants={{ hidden: { opacity: 0, scale: 0.95 }, show: { opacity: 1, scale: 1 }}}
            initial="hidden"
            animate="show"
          >
            {!TestMode && !review.sent &&
              <Fragment>
                <div className="component_textzone_cont" style={{fontWeight:"bold", fontSize:"16px"}} >
                  {getLabel("ProcessPage", "Did the troubleshooting...")}
                </div>
                <ReviewComponent
                  Rating={review.rating}
                  SetRating={onClickRating}
                />
                <textarea
                  className={"page_textarea_input"}
                  rows={2}
                  value={review.comment}
                  type="text"
                  style={{maxWidth: "400px"}}
                  disabled={loading}
                  onChange={onChangeComment}
                  onKeyDown={handleClickReview}
                />
                <div className="component_row_input" style={{ marginTop: "10px" }}>
                  < input
                    type="button"
                    className="page_button process_button"
                    value={getLabel("ProcessPage", "Send review")}
                    style={{ width: "300px" }}
                    onClick={onSendReview}
                  />
                </div>
              </Fragment>
            }
            {!TestMode && review.sent &&
              <div className="component_textzone_cont" style={{ fontWeight: "bold", fontSize: "16px" }} >
                {getLabel("ProcessPage", "Thank you for submitting your review.")}
              </div>
            }
            <div className="component_cont">
              {!TestMode && 
                <div className="component_row_input" style={{ marginTop: "20px" }}>
                  < input
                    type="button"
                    className="page_button process_button"
                    value={getLabel("ProcessPage", "Contact technical support")}
                    style={{width: "300px"}}
                    onClick={onClickContact}
                  />
                </div> 
              }
              <div className="component_row_input" style={{ marginTop: "10px" }}>
                < input
                  type="button"
                  className="page_button process_button"
                  value={getLabel("ProcessPage", "Try again")}
                  style={{ width: "300px" }}
                  onClick={onTryAgain}
                />
              </div>
              <div className="component_row_input" style={{ marginTop: "10px" }}>
                < input
                  type="button"
                  className="page_button process_button"
                  value={getLabel("ProcessPage", "Home")}
                  style={{ width: "300px" }}
                  onClick={OnGoHome}
                />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    );


  }

  return (
    <div className="page_body_cont">
      <LoadingComponent
        display={loading}
        label={getLabel("App", "Loading")}
      />
      <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
      />
      <ConfirmModal
        Display={confirm.Display}
        Title={confirm.Title}
        Message={confirm.Message}
        Cancel={confirm.Cancel}
        onCancel={confirm.onCancel}
        Confirm={confirm.Confirm}
        onConfirm={confirm.onConfirm}
      />
      {report && 
        <ProcessReport
          IsDesktop={IsDesktop}
          Product={Product}
          Process={Process}
          Step={currentStep}
          Path={path}
          Value={value}
          OnCloseModal={() => setReport(false)}
        />
      }
      <div className="page_cont">
        {TestMode &&
          <div className="process_step_title">
            [ {currentStep ? currentStep.title : "-"} ]
          </div>
        }
        <div className="process_navigation_cont">
          <div className="process_navigation_col" style={{ width: "100px" }} title={getLabel("ProcessPage", "Back")}>
            <div className="process_navigation_button" onClick={onGoBack}>
              <ImArrowLeft />
            </div>
          </div>
          <div className="process_navigation_col" style={{ width: "100px" }} title={getLabel("ProcessPage", "Home")}>
            <div className="process_navigation_button" style={{ fontSize: "30px" }} onClick={onGoHome}>
              <MdHome />
            </div>
          </div>
          <div className="process_navigation_col" style={{ width: "100px" }} title={getLabel("ProcessPage", "Next")}>
            <div className="process_navigation_button" onClick={() => onClickButton(currentStep.navigationButton)}>
              <ImArrowRight  />
            </div>
          </div>
        </div>
          {currentStep.component.map((c, index) => (
            <motion.div
              style={{ willChange: "none" }}
              variants={{ hidden: { opacity: 0, scale: 0.95 }, show: { opacity: 1, scale: 1 }}}
              initial="hidden"
              animate="show"
              key={index + "_" + c._id}
            >
              <ComponentEntity
                key={index + "_" + c._id}
                IsDesktop={IsDesktop}
                Edit={false}
                Data={c}
                Value={value.find(v => v.step == currentStep._id && v.component == c._id)}
                Error={error[c._id] || ""}
                OnChangeValue={onChangeValue}
                OnChangeValueCustom={onChangeValueCustom}
                OnClickButton={onClickButton}
              />
            </motion.div>
          ))}
          <motion.div className="component_cont"
            variants={{ hidden: { opacity: 0, scale: 0.95 }, show: { opacity: 1, scale: 1 }}}
            initial="hidden"
            animate="show"
            key={currentStep._id}
          >
              
            <div className="component_row_input" style={{ marginTop: "40px" }}>
                < input
                  type="button"
                className="page_button process_button"
                  value={getLabel("ProcessPage", "Next")}
                  onClick={() => onClickButton(currentStep.navigationButton)}
                />
            </div>
          </motion.div>
        {!TestMode && !report &&
          <div className="process_report_icon" 
          onClick={onClickReport}
          title={getLabel("ProcessPage", "Report an issue")}>
          <MdBugReport />
        </div>
        }
      </div>
    </div>
  );

};

export default ProcessPage